const LOADING = {
  IMPORT: "Importing Please Wait",
  DSC_REGISTER:"DSC Registering... Please Wait",
  DELETE:"Removing... Please Wait",
  LOADING:"Loading... Please Wait",
  GENERATE:"Generating... Please Wait"
};

export { LOADING };

